/**
 * Design tokens for Maloum CRM — utilitarian dense dashboard (D-03).
 *
 * Used by both admin-app and chatter-app via @crm/ui/tokens.
 * Tailwind 4 CSS variables consumed in tailwind.config.*
 */

export const tokens = {
  colors: {
    // Background scale
    bg: 'hsl(0 0% 5%)',
    bgCard: 'hsl(0 0% 9%)',
    bgInput: 'hsl(0 0% 12%)',
    bgHover: 'hsl(0 0% 15%)',

    // Borders
    border: 'hsl(0 0% 20%)',
    borderFocus: 'hsl(220 80% 60%)',

    // Text
    text: 'hsl(0 0% 96%)',
    textMuted: 'hsl(0 0% 60%)',
    textSubtle: 'hsl(0 0% 40%)',

    // Brand accent (deep blue — utilitarian, not loud)
    accent: 'hsl(220 80% 60%)',
    accentHover: 'hsl(220 80% 55%)',
    accentFg: 'hsl(0 0% 100%)',

    // Semantic status
    success: 'hsl(142 70% 45%)',
    successFg: 'hsl(142 70% 95%)',
    warning: 'hsl(38 95% 55%)',
    warningFg: 'hsl(38 95% 10%)',
    danger: 'hsl(0 75% 55%)',
    dangerFg: 'hsl(0 75% 97%)',
    info: 'hsl(200 80% 50%)',
    infoFg: 'hsl(200 80% 97%)',

    // Health FSM colours
    online: 'hsl(142 70% 45%)',
    reconnecting: 'hsl(38 95% 55%)',
    needs_reauth: 'hsl(0 75% 55%)',
    cf_blocked: 'hsl(280 60% 55%)',
    dead: 'hsl(0 0% 35%)',
    connecting: 'hsl(200 80% 50%)',
  },
  spacing: {
    px: '1px',
    0: '0',
    0.5: '0.125rem',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    6: '1.5rem',
    8: '2rem',
    12: '3rem',
    16: '4rem',
  },
  font: {
    sans: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'sans-serif',
    ].join(', '),
    mono: [
      '"JetBrains Mono"',
      '"Fira Code"',
      '"Cascadia Code"',
      'monospace',
    ].join(', '),
    sizeSm: '0.75rem',
    sizeBase: '0.875rem',
    sizeLg: '1rem',
    sizeXl: '1.125rem',
    size2xl: '1.25rem',
  },
  radius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px',
  },
} as const;

export type Tokens = typeof tokens;
